export class CombinedWastageDetailDto {
  merchantId: number;
  costCentreId: number;
  stockCategoryId: number;
  lastModifiedUserId?: number;
  stockWastageId?: number;
  weekNo?: number;
  monthNo?: number;
  year?: number;
  wastageDay: string;
  closed?: boolean;
  isProduct?: boolean;
  stockLevelDetails: StockWastageDetail[];
  recipeLevelDetails: RecipeWastageDetail[];
}

class StockWastageDetail {
  id?: number;
  stockId: number;
  stockUnitId?: number;
  storageLocationId: number;
  isStockFromRecipe?: boolean;
  quantity?: number;
  outOfStock?: boolean;
  caseQty: number;
  unitQty: number;
  splitQty: number;
  totalValue?: number;
  totalAMT?: number;
}

class RecipeWastageDetail {
  id?: number;
  recipeId: number;
  storageLocationId: number;
  quantity?: number;
  outOfStock?: boolean;
  batchQty: number;
  portionQty: number;
  splitQty: number;
  totalValue?: number;
  totalAMT?: number;
}
